import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import { useOrder } from '../../../Providers/OrderProvider';
import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import { useNavigate } from 'react-router-dom'
import { FaRegEdit } from 'react-icons/fa'
import OrdersFilterSection from './OrdersFilterSection'
import OrderPositions from './OrderPositions';

import '../Styles/Orders.css'
import { useParams } from '../../../Providers/ParamsProvider';

const Orders = ({ orders, isArchive, isLoading, onChangeNameButtonClick, setSelectedOrders, ordersFilterCriteria, setOrdersFilterCriteria, lastBookElementRef }) => {
    const { t } = useTranslation();
    const { isMobile } = useParams();

    const handleCheckUncheckOrder = (order, isChecked) => {
        if (isChecked) {
            setSelectedOrders(prev => [...prev, order])
        }
        else {
            setSelectedOrders(prev => prev.filter(o => o.ordersNumber !== order.ordersNumber))
        }
    }
    return (<div>

        <div className='row justify-content-center'>
            <div className='justify-content-center'>
                {/* Sekcja filtrów */}
                <OrdersFilterSection
                    ordersFilterCriteria={ordersFilterCriteria}
                    setOrdersFilterCriteria={setOrdersFilterCriteria}
                />
                <div className='table-responsive'>
                    {/* Sekcja z tabelką */}
                    <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                        <thead>
                            <tr>
                                <th style={{ alignContent: 'center', verticalAlign: 'middle', width: '5%' }}></th>
                                <th style={{ width: '18%', verticalAlign: 'middle', fontSize: '14px' }}>
                                    <span style={{ fontWeight: 'normal' }}>{t("number_table_header_orders_page").toLocaleUpperCase()}</span><br />
                                    {t("number_cust_table_header_orders_page").toLocaleUpperCase()}
                                </th>
                                <th style={{ width: '10%', verticalAlign: 'top', fontSize: '14px' }}>
                                    {t("Date_table_header_orders_page").toLocaleUpperCase()}
                                </th>
                                <th style={{ width: '15%', verticalAlign: 'top', fontSize: '14px' }} >
                                    {t("seller_table_header_orders_page").toLocaleUpperCase()}
                                </th>
                                <th style={{ width: '15%', verticalAlign: 'top', fontSize: '14px' }}>
                                    {t("address_table_header_orders_page").toLocaleUpperCase()}
                                </th>
                                <th style={{ width: '10%', verticalAlign: 'top', fontSize: '14px', textAlign: 'right' }}>
                                    {t("netto_table_header_orders_page").toLocaleUpperCase()}
                                </th>
                                <th style={{ width: 'auto', verticalAlign: 'top', fontSize: '14px' }}>
                                    {t("comments").toLocaleUpperCase()}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders && orders.map((order, index) => {
                                return <OrderHead key={index} order={order} onChangeNameButtonClick={onChangeNameButtonClick} handleCheckUncheck={handleCheckUncheckOrder} isArchive={isArchive} lastBookElementRef={lastBookElementRef} />
                            })}
                        </tbody>
                    </table>
                    {isLoading && <LoadingSpinner />}
                    {!isLoading && orders && orders.length === 0 && orders && <div style={{ textAlign: 'center' }}>{(isArchive) ? t("message_norecords_archive_orders_page") : t("message_norecords_orders_page")}</div>}
                </div>
            </div>
        </div>
    </div>
    )
}

const OrderHead = ({ order, onChangeNameButtonClick, handleCheckUncheck, isArchive, lastBookElementRef }) => {
    const [ordersValue, setOrdersValue] = useState(0)
    const [showItems, setShowItems] = useState(false)
    const [isLoadingItems, setIsLoadingItems] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate()
    const { setSelectedOrderDetails } = useOrder()

    useEffect(() => {
        let ordersValue = 0;
        order.products.forEach(product => {
            ordersValue += (product.priceNetto * product.qtyStock)
        });
        setOrdersValue(ordersValue);
        setIsChecked(false)

    }, [order])

    const handleCheckboxChange = (e) => {
        if (isChecked) {
            setIsChecked(false)
            handleCheckUncheck(order, false)
        } else {
            setIsChecked(true)
            handleCheckUncheck(order, true)
        }
    };

    const handleRedirect = (selectedOrder) => {
        setSelectedOrderDetails(selectedOrder)
        navigate(`/order/${order.ordersNumber}`, { state: { selectedOrderDetails: selectedOrder } })
    }

    function reverseDate(date) {
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
    }
    return (<>
        <tr className='hoverable-row' ref={lastBookElementRef}>
            <td style={{ verticalAlign: 'middle' }}>
                <div
                    onClick={handleCheckboxChange}
                    style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: isChecked ? 'var(--primary)' : "var(--secondary)",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                    }}
                >
                    {isChecked && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="white"
                            width="16px"
                            height="16px"
                        >
                            <path d="M20.285,6.707l-11.32,11.32c-0.39,0.39-1.024,0.39-1.414,0L3.715,14.49c-0.39-0.39-0.39-1.024,0-1.414l1.414-1.414c0.39-0.39,1.024-0.39,1.414,0L9,14.043l9.857-9.857c0.39-0.39,1.024-0.39,1.414,0l1.414,1.414C20.675,5.683,20.675,6.317,20.285,6.707z" />
                        </svg>
                    )}
                </div>
            </td>
            <td style={{ fontSize: '14px' }}>
                <div onClick={() => handleRedirect(order)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                    {order.ordersNumber + "/" + order.siteId}<br />
                </div>
                <div onClick={() => onChangeNameButtonClick(order)} >
                    <span style={{ fontWeight: 'bold' }}>{order.custOrderNumber === "" ? 'mój numer zamówienia' : order.custOrderNumber}</span>
                    <button style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <FaRegEdit color='black' />
                    </button>
                </div>
            </td>
            <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
                {reverseDate(order.ordersDate.substring(0, order.ordersDate.indexOf('T')))}
            </td>
            <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
                {order.seller}
            </td>
            <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
                {order.address}
            </td>
            <td style={{ fontSize: '14px', verticalAlign: 'middle', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
                {ConvertPriceToString(ordersValue, null)}
            </td>
            <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
                {order.comments}
            </td>
        </tr >
        {showItems && (
            <tr>
                <td colSpan='9' style={{ padding: 10 }}>
                    <OrderPositions items={order.products} isLoading={isLoadingItems} isArchive={isArchive} />
                </td>
            </tr>
        )
        }


    </>
    );
}

export default Orders